import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

export default function TrustedCaRetailersSection() {
    return (<div className="testimonials">
        <h2 className="features-title">Trusted by California Retailers</h2>
        <div className="custom-container d-flex items-center width-100">
            <div className="features-grid testimonials-grid d-flex items-center justify-center">
                <div className="feature-card-retailer px-20 py-24"> 
                    <p className="pb-16">"LottoReco cut our closing time from 45 minutes to just 5 minutes. The receipt scanning feature is incredible – it reads everything perfectly every time."</p>
                    <h3>Balraj</h3>
                    <span>Owner, Chevron Gas Mountain View</span>
                    <FormatQuoteIcon className='quotes-icon' /> 
                </div>
                <div className="feature-card-retailer px-20 py-24"> 
                        <p className="pb-16">"We caught a $200 discrepancy on our first day using LottoReco. The theft prevention features alone have paid for the entire system.”</p>
                        <h3>Sunny</h3>
                        <span>Owner Mobil- Woodside Gas and C-Store</span>
                        <FormatQuoteIcon className='quotes-icon' /> 
                </div> 
            </div>
        </div>
    </div>
    );
}